import script from "./MemorialDonationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MemorialDonationsPage.vue?vue&type=script&setup=true&lang=js"

import "./MemorialDonationsPage.vue?vue&type=style&index=0&id=00486290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00486290"]])

export default __exports__